import { SxProps, Theme } from '@mui/material';

export const visuallyHidden: SxProps<Theme> = {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1,
};
